import { render, staticRenderFns } from "./VSelectAdd.vue?vue&type=template&id=3f54ed59"
import script from "./VSelectAdd.vue?vue&type=script&lang=js"
export * from "./VSelectAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports